import { IFilterDataItem } from "components/Filters/filtersOptions";
import { IRadioButtonItem } from "components/Filters/RadioButtonsFilter/RadioButtonsFilter";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

enum ESurfaceTypes {
  ALL_SURFACES = "All Surfaces",
  DIRT = "Dirt",
  SYNTHETIC = "Synthetic",
  TURF = "Turf"
}

enum EGenderTypes {
  ALL_GENDERS = "All Genders",
  MALE = "Male",
  FEMALE = "Female"
}

export const MIN_VALUE = 0;
export const MAX_VALUE = 180;
export const MIN_DISTANCE = 1;
export const SUB_TITLE =
  "Display only horses that have raced within the specified time range.";
export const initialDaysSinceLastRace = [MIN_VALUE, MAX_VALUE];

export const surfaceTypes: IRadioButtonItem[] = [
  {
    label: ESurfaceTypes.ALL_SURFACES,
    value: racehorse360.CourseSurface.COURSE_SURFACE_INVALID
  },
  {
    label: ESurfaceTypes.DIRT,
    value: racehorse360.CourseSurface.COURSE_SURFACE_DIRT
  },
  {
    label: ESurfaceTypes.SYNTHETIC,
    value: racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRACK
  },
  {
    label: ESurfaceTypes.TURF,
    value: racehorse360.CourseSurface.COURSE_SURFACE_TURF
  }
];

export const genderTypes: IRadioButtonItem[] = [
  {
    label: EGenderTypes.ALL_GENDERS,
    value: racehorse360.RaceConditionGender.RACE_CONDITION_GENDER_INVALID
  },
  {
    label: EGenderTypes.MALE,
    value: racehorse360.RaceConditionGender.RACE_CONDITION_GENDER_OPEN
  },
  {
    label: EGenderTypes.FEMALE,
    value:
      racehorse360.RaceConditionGender.RACE_CONDITION_GENDER_FILLIES_AND_MARES
  }
];

export const ageTypes: IFilterDataItem[] = [
  {
    label: "2yo",
    value: String(racehorse360.RaceConditionAge.RACE_CONDITION_AGE_TWO)
  },
  {
    label: "3yo",
    value: String(racehorse360.RaceConditionAge.RACE_CONDITION_AGE_THREE)
  },
  {
    label: "4yo+",
    value: String(racehorse360.RaceConditionAge.RACE_CONDITION_AGE_FOUR_PLUS)
  }
];

export const defaultFiltersState = {
  daysSinceLastRace: initialDaysSinceLastRace,
  selectedSurface: surfaceTypes[0].value,
  selectedGender: genderTypes[0].value,
  selectedDistances: null,
  selectedRaceTypes: null,
  selectedClaimingPrices: null,
  selectedAge: null
};
